export default {
  title: 'Personaleloginoplysninger',
  form: {
    username: {
      label: 'Brugernavn',
      placeholder: 'Brugernavn',
    },
    password: {
      label: 'Adgangskode',
      placeholder: 'Adgangskode',
    },
    button: {
      title: 'Gem',
    },
    success: 'Dine oplysninger er gemt.',
  },
};
